/**
 * @author: dongjing
 * @file: description
 * @Date: 2019-12-02 12:15:36
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-03-24 13:29:37
 */
import { all } from 'redux-saga/effects';
// @ts-ignore
import * as commonSaga from '@features/common/redux/sagas';
// @ts-ignore
import * as homeSaga from '@features/home/redux/sagas';
import * as searchSaga from '@features/search/redux/sagas';
import * as personalSaga from '@features/personal/redux/sagas';
import * as articleSaga from '@features/article/redux/sagas';
import * as articlesSaga from '@features/articles/redux/sagas';
import * as messageSaga from '@features/message/redux/sagas';
import * as askSaga from '@features/ask/redux/sagas';
import * as tagSaga from '@features/tag/redux/sagas';
import * as circleSaga from '@features/circle/redux/sagas';
import * as teamSaga from '@features/team/redux/sagas';
import * as voteSaga from '@features/vote/redux/sagas';
import * as adminSaga from '@features/admin/redux/sagas';
import * as activeSaga from '@features/active/redux/sagas';
import * as mallSaga from '@features/mall/redux/sagas';
import * as thematicSaga from '@features/thematic/redux/sagas';

const featureSagas: { [g: string]: () => void }[] = [
  commonSaga,
  homeSaga,
  searchSaga,
  personalSaga,
  articleSaga,
  articlesSaga,
  messageSaga,
  askSaga,
  tagSaga,
  circleSaga,
  teamSaga,
  voteSaga,
  adminSaga,
  activeSaga,
  mallSaga,
  thematicSaga
];

const sagas = featureSagas
  .reduce((prev, curr) => [...prev, ...Object.keys(curr).map(k => curr[k])], [])
  .filter(s => typeof s === 'function');

export default function* rootSaga() {
  yield all(sagas.map(saga => saga()));
}
